<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="64"
    height="64"
    viewBox="0 0 64 64"
    fill="none"
  >
    <circle cx="32" cy="32" r="32" fill="#FEC84B" />
    <path
      d="M28.12 28.0003C28.4334 27.1092 29.0522 26.3578 29.8666 25.8792C30.681 25.4005 31.6385 25.2256 32.5695 25.3853C33.5006 25.545 34.345 26.029 34.9534 26.7517C35.5617 27.4744 35.8947 28.389 35.8933 29.3337C35.8933 32.0003 31.8933 33.3337 31.8933 33.3337M32 38.667H32.0133M45.3333 32.0003C45.3333 39.3641 39.3638 45.3337 32 45.3337C24.6362 45.3337 18.6666 39.3641 18.6666 32.0003C18.6666 24.6365 24.6362 18.667 32 18.667C39.3638 18.667 45.3333 24.6365 45.3333 32.0003Z"
      stroke="#683928"
      stroke-width="3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
